import { createGlobalStyle } from 'styled-components'
import { PancakeTheme } from '@pancakeswap/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
  }
  body {
    background-color: ${({ theme }) => theme.colors.background};
    background-image: linear-gradient(180deg, #FDF2F8 0%, #FAFBFC 300px);
    background-repeat: no-repeat;

    img {
      height: auto;
      max-width: 100%;
    }
  }

  [data-theme="dark"] body {
    background-image: radial-gradient(circle at 50% 0%, rgba(95, 203, 130, 0.2) 0%, rgba(95, 203, 130, 0) 320px);
  }

  #__next {
    position: relative;
    z-index: 1;
  }

  #portal-root {
    position: relative;
    z-index: 2;
  }
`

export default GlobalStyle
